
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workers-compensation",
      function () {
        return require("private-next-pages/workers-compensation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workers-compensation"])
      });
    }
  